import {
    ExtendRmsFiltersParams,
    useExtendedRmsAccountFilters,
} from '@/ui/features/contact-management/AccountsPanel/hooks/useExtendedRmsAccountFilters';
import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountList';
import { useExtendedCredentialingAccountsFilters } from '@juvare/credentialing/ui/hooks';

export function useExtendedAccountsFilters() {
    const { extendCredentialingFilters } = useExtendedCredentialingAccountsFilters();
    const { extendRmsFilters } = useExtendedRmsAccountFilters();

    const extendFilters = (builder: FilterConfigBuilder<AccountFilterData>, params: ExtendRmsFiltersParams = {}) => {
        extendCredentialingFilters(builder, { regionEnabled: true });
        extendRmsFilters(builder, params);
    };

    return {
        extendFilters,
    };
}
